<template>
  <div class="content-contents">
    <naj-box
      :title="local.complaints.complaintDetails.complaintUserInfo.title"
      header-icon="mdi-account"
      header-class="sub-header"
      disable-collapsing
    >
      <profile-details
        :user-object="complaintObj.applyComplainant"
        :is-profile="false"
        :show-modify-mobile="false"
      ></profile-details>
    </naj-box>
    <naj-box
      v-if="complaintObj.selectedCategoryId == mainComplaintCategories.relatedToExecution"
      :title="local.complaints.executionRequestInfo.title"
      header-icon="mdi-format-list-bulleted-square"
      header-class="sub-header"
      disable-collapsing
    >
      <execution-verification :complaint-obj="complaintObj"></execution-verification>
    </naj-box>
    <case-details
      v-if="complaintObj.selectedCategoryId == mainComplaintCategories.relatedToCase"
      :complaint="getCaseData || {}"
    ></case-details>
    <v-row
      v-if="complaintObj.subCategories && complaintObj.subCategories.length >1"
      class="ma-0"
    >
      <v-col
        cols="4"
        class="pb-0 pt-0 px-5"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="complaintObj.subCategoryId"
          :label="local.complaints.newComplaint.complaintCategoryTab.complaintCategories"
          :items="complaintObj.subCategories"
          item-value="id"
          item-text="name"
          disabled
        ></naj-input>
      </v-col>
    </v-row>
    <v-row
      v-if="showDetailsMode && complaintObj.subCategoryName"
      class="ma-0"
    >
      <v-col
        cols="4"
        class="pb-0 pt-0 px-5"
      >
        <naj-input
          v-if="showDetailsMode"
          :type-id="formFieldType.text"
          :value.sync="complaintObj.subCategoryName"
          :label="local.complaints.newComplaint.complaintCategoryTab.complaintCategories"
          :disabled="true"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col
        cols="12"
        class="px-2"
      >
        <div class="dynamic-form-container">
          <naj-dynamic-form
            :form-model.sync="complaintObj.complaintForm.formModel"
            :form-fields.sync="complaintObj.complaintForm.formFields"
            :custom-component-name.sync="complaintObj.complaintForm.customComponentName"
            :view-mode.sync="complaintObj.complaintForm.formModel.viewMode"
          ></naj-dynamic-form>
        </div>
      </v-col>
    </v-row>

    <div
      v-if="!showDetailsMode"
      class="button-container"
    >
      <naj-button
        class="left-button"
        @click="cancel()"
      >
        {{ local.common.cancel }}
      </naj-button>
      <div class="right-buttons">
        <naj-button
          type="button"
          color="#89743e"
          icon="mdi-arrow-right"
          @click="previous"
        >
          {{
            local.common.previous
          }}
        </naj-button>
        <naj-button
          type="button"
          :loading="loading"
          @click="submit"
        >
          {{
            local.common.submit
          }}
        </naj-button>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileDetails from '../profile/profile-details.vue';
import { mainComplaintCategories } from '@/modules/complaints/helpers/enum';
import CaseDetails from '../home/case-details.vue';
import ExecutionVerification from './verification-components/execution-verification.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'ComplaintPreviewTab',
  components: {
    ProfileDetails,
    CaseDetails,
    ExecutionVerification,
  },
  props: {
    complaintObj: {
      type: Object,
      default: () => ({}),
    },
    showDetailsMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      mainComplaintCategories,
    };
  },
  computed: {
    getCaseData() {
      var caseData = this.complaintObj.complaintForm.formModel.selectedCase;
      if (caseData) {
        return {
          caseNo: caseData.caseCode,
          caseDateH: caseData.date,
          caseStatus: caseData.status,
          applyTypeName: caseData.relation,
          cRequestTypeName: caseData.type,
          courtName: caseData.court,
          subCircleName: caseData.circle,
        };
      }
      else
        return null;
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    ...mapComplaintsActions([
      'saveComplaint',
      'notifyComplainant',
    ]),
    cancel() {
      this.$emit('cancel');
    },
    previous() {
      this.complaintObj.complaintForm.formModel.viewMode = false;
      this.$emit('changeTab', 'tab-3');
    },
    submit() {
      let complaintCopy = JSON.parse(JSON.stringify(this.complaintObj));

      complaintCopy.AttachmentList = complaintCopy.complaintForm.formModel.AttachmentList;
      (complaintCopy.AttachmentList || []).forEach((element) => {
        element.attachmentStr = element.attachmentBase64.split(',')[1];
        delete element.attachmentBase64;
      });
      delete complaintCopy.complaintForm.formModel.AttachmentList;

      this.loading = true;
      //complaintCopy.complaintForm.formFields = this.getShownFields(this.complaintObj.complaintForm.formFields, this.complaintObj.complaintForm.formModel.shown);

      this.saveComplaint(complaintCopy)
        .then((data) => {
          if (data && data.data && data.data.data.complaintID) {
            this.notifyComplainant({ message: this.local.complaints.newComplaint.userInfoTab.notifySMSMessage(this.complaintObj.applyComplainant.officialId, data.data.data.complaintID) });
            this.$emit('submit', data.data.data.complaintID);
          }
        })
        .finally(() => { this.loading = false; });
    },
    getShownFields(fields, shown) {
      if (!fields || fields.length == 0)
        return fields;
      else {

        var shownFields = fields.filter((i) => {
          return shown[i.name + '_' + i.id];
        });
        shownFields.forEach((item) => {
          item.fields = this.getShownFields(item.fields, shown);
        });
        return shownFields;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.left-button {
  margin-left: 10px;
}
.right-buttons {
  display: flex;
}

::v-deep {
  .v-data-table__wrapper {
    div {
      text-wrap: pretty;
    }
  }
}

.dynamic-form-container {
  ::v-deep {
    > div {
      > .row {
        margin: 0;
      }
    }
  }
}
</style>
